// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3qFhS","tab":"Tabs_tab__1PcXn","tabActive":"Tabs_tabActive__3-uj7"};